import React, { useState } from 'react';
import styles from '../ATSPage.module.css';
import { JobInfo } from '../hooks/useATSData';
import ExpandedContentModal from '../../../components/Modals/ExpandedContentModal';

interface ATSHeaderProps {
  jobInfo: JobInfo;
  onCloseJob: () => void;
}

const ATSHeader: React.FC<ATSHeaderProps> = ({ jobInfo, onCloseJob }) => {
  const [isJDOpen, setIsJDOpen] = useState(false);

  return (
    <div className={styles.atsHeader} data-testid="ats-header">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 className={styles.atsHeaderTitle} data-testid="ats-header-title">{jobInfo.title}</h1>

      </div>

      <div className={styles.jobInfoHeader}>
        <div>
          <span className={styles.jobInfoLabel} data-testid="ats-header-salary-label">Salary</span>
          <span className={styles.jobInfoValue} data-testid="ats-header-salary">{jobInfo.salary || 'N/A'}</span>
        </div>
        <div>
          <span className={styles.jobInfoLabel} data-testid="ats-header-status-label">Status</span>
          <span
            className={`${styles.jobInfoValue} ${jobInfo.status === 'Open' ? styles.jobInfoValueOpen : styles.jobInfoValueFilled
              }`}
            data-testid="ats-header-status"
          >
            {jobInfo.status}
          </span>
        </div>
        <div>
          <span className={styles.jobInfoLabel} data-testid="ats-header-hires-label">Hired</span>
          <span className={styles.jobInfoValue} data-testid="ats-header-hires">{jobInfo.hires}</span>
        </div>
        <div>
          <span className={styles.jobInfoLabel} data-testid="ats-header-positions-label">Positions</span>
          <span className={styles.jobInfoValue} data-testid="ats-header-total-positions">{jobInfo.totalPositions}</span>
        </div>
        <div>
          <span className={styles.jobInfoLabel}>Description</span>
          <button
            className={styles.jdButton}
            onClick={() => setIsJDOpen(true)}
            data-testid="ats-header-jd-button"
            disabled={!jobInfo.description}
          >
            View
          </button>
        </div>
        {jobInfo.status !== 'Closed' && jobInfo.status !== 'Filled' && (
          <div style={{ marginLeft: 'auto', alignSelf: 'center' }}>
            <button className={styles.closeJobButton} onClick={onCloseJob} data-testid="ats-header-close-job-button">
              Close Job
            </button>
          </div>
        )}
      </div>

      <ExpandedContentModal
        isOpen={isJDOpen}
        onClose={() => setIsJDOpen(false)}
        title="Job Description"
        content={jobInfo.description || ''}
        readOnly={true}
      />
    </div>
  );
};

export default ATSHeader;
